exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/bdegroot/Projects/vgtropics-ph/src/app/login/login.component.css
// module id = ../../../../../src/app/login/login.component.css
// module chunks = main